import styled from 'styled-components';
import { Divider, Row } from 'antd';

export const Content = styled(Row)`
	margin-left: 12px;
`;

export const CustomDivider = styled(Divider)`
	margin: 0;
	height: 100%;
	border-left: 1px solid #e6e8e8;
`;

export const Label = styled.span`
	font-size: 1rem;
	font-weight: 600;
	margin-right: 0.5rem;
`;

export const Value = styled.span`
	font-size: 1rem;
	font-weight: 400;
`;
